import { flow, Instance, types } from 'mobx-state-tree'
import { getHeader, setHeader } from '../../network/config'
import { verifyCred } from '../../network/verifyCred'
import { getErrorMsg } from '../../util/util'
import { activateQrReq } from '../QrAgentRequest/activateQrCode'
import { AppExpireReq } from '../QrAgentRequest/AppExpireReq'
import { generateOTP } from '../QrAgentRequest/generateOtp'
import { getMidsQrListReq } from '../QrAgentRequest/getMidsQrList'
import { loginVerifyOtp } from '../QrAgentRequest/loginVerifyOtp'
import { logoutRequest } from '../QrAgentRequest/logoutRequest'
import { getAppLoginRequestBody } from '../request/requestbody'
import { customError } from '../static/strings'
import { RootStore } from '../store'

const Mid: any = types.model('Mid', {
  id: types.optional(types.string, ''),
  tid: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
  mobile: types.optional(types.string, ''),
  status: types.optional(types.string, ''),
})
const QrCodeUser: any = types
  .model('User', {
    id: types.optional(types.number, -1),
    mobile: types.optional(types.string, ''),
    jfsUserId: types.optional(types.string, ''),
    midList: types.optional(types.array(Mid), []),
  })
  .actions((self) => ({
    getAppAuthGenOtpOrLogin: flow(function* getAppAuthGenOtpOrLogin(mobile: string) {
      try {
        const firstReqBody = getAppLoginRequestBody(mobile)
        let responseAppAuth = yield verifyCred(firstReqBody, RootStore.agentQrSession.getTokens)
        if (responseAppAuth.status === 'SUCCESS') {
          RootStore.agentQrSession.updateAppTokens(responseAppAuth)
        } else {
          throw responseAppAuth
        }

        const header = {
          ...getHeader(),
          'x-app-access-token': RootStore.agentQrSession.appAccessToken || '', //not required.
          'x-appid-token': RootStore.agentQrSession.appIdToken || '',
        }
        setHeader(header)
        const mobileNum = self?.mobile ?? ''
        let resUserAuthGen = yield generateOTP(mobileNum, RootStore.agentQrSession.getTokens)
        // : yield userAuthenticate(RootStore.agentQrSession.myJioSession, RootStore.agentQrSession.jTokenId, self.mobile) //TODO: Check myjio related
        if (resUserAuthGen) {
          // RootStore.agentQrSession.updateUserTokens(resUserAuthGen)
        }
        // self.user.agentQrSession.userAccessToken = resUserAuthGen?.accessToken
        // self.user.agentQrSession.userIdToken = resUserAuthGen?.identifierToken
        // self.user.agentQrSession.ssoToken = resUserAuthGen?.accessToken
        // self.user.agentQrSession.refreshToken = resUserAuthGen?.refreshToken
        const userHeader = {
          ...getHeader(),
          'x-user-access-token': RootStore.agentQrSession.userAccessToken || '', //not required.
          'x-userid-token': RootStore.agentQrSession.userIdToken || '',
        }
        setHeader(userHeader)
      } catch (error) {
        console.log('getAppAuthGenOtpOrLogin', error)
        RootStore?.response?.setMessage(getErrorMsg(error?.code, error?.message) ?? customError.errorOccured)
        throw error
      }
    }),
    generateOtp: flow(function* generateOtp() {
      try {
        let resUserAuthGen = yield generateOTP(self.mobile, RootStore.agentQrSession.getTokens)
        if (resUserAuthGen) {
          RootStore.agentQrSession.updateUserTokens(resUserAuthGen)
        }
        const userHeader = {
          ...getHeader(),
          'x-user-access-token': RootStore.agentQrSession.userAccessToken || '', //not required.
          'x-userid-token': RootStore.agentQrSession.userIdToken || '',
        }
        setHeader(userHeader)
      } catch (error) {
        console.log('generateOtp error', error)
        RootStore?.response?.setMessage(getErrorMsg(error?.code, error?.message) ?? customError.errorOccured)
        throw error
      }
    }),
    updateMobileNumber(mobile: string) {
      const own = self
      own.mobile = mobile.toString()
    },
    loginVerifyOTP: flow(function* loginVerifyOTP(otp: string) {
      let response
      try {
        response = yield loginVerifyOtp(
          otp,
          self.mobile,
          RootStore.agentQrSession.getTokens,
          RootStore.agentQrSession.userAccessToken,
        )
        //TODO: check and uncomment
        // if (isExistingUser) {
        const agentQrSession = response?.data
        RootStore.agentQrSession.updateUserTokens(response?.data)
        const userHeader = {
          ...getHeader(),
          'x-user-access-token': agentQrSession?.accessToken?.tokenValue || '', //not required.
          'x-userid-token': agentQrSession?.identifierToken || '',
        }
        setHeader(userHeader)
        // }
      } catch (error) {
        console.log('loginVerifyOTP', error)

        RootStore?.response?.setMessage(getErrorMsg(error?.code, error?.message) ?? customError.errorOccured)
        throw error
      }
      return response
    }),

    getMidsQrList: flow(function* getMidsQrList() {
      let response
      console.log('===> getMidsQrList api call', self.mobile)
      try {
        response = yield getMidsQrListReq(self.mobile, RootStore.agentQrSession.getTokens)
        self.midList = response
      } catch (e) {
        window.localStorage.removeItem('csoSessData')
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw customError
      }
      return response
    }),
    activateQrCode: flow(function* activateQrCode(mid: string, tid: string, vpa: string, mobile: string) {
      let response
      try {
        response = yield activateQrReq(mid, tid, vpa, mobile, RootStore.agentQrSession.getTokens)
        if (response.status === 'SUCCESS' && response.response.qrId.length > 0) {
          console.log('response.response.qrId', response.response.qrId)
        }
      } catch (e) {
        console.log('activateQrCode', e)
        RootStore?.response?.setMessage(e?.data?.error?.message ?? customError.errorOccured)
        throw customError
      }
      return response
    }),

    logout: flow(function* logout(callApi: boolean = true) {
      try {
        if (callApi) {
          yield logoutRequest(
            {
              accessToken: RootStore.session.userAccessToken ?? '',
              refreshToken: RootStore.session.userRefreshToken ?? '',
              userIdentifierToken: RootStore.session.userIdToken ?? '',
            },
            RootStore.session.getTokens,
          )
          yield AppExpireReq(
            {
              accessToken: RootStore.session.appAccessToken ?? '',
            },
            RootStore.session.getTokens,
          )
        }
        window.localStorage.removeItem('csoUserMobileNumber')
        window.localStorage.removeItem('csoSessData')
      } catch (error) {
        console.log('logout', error)
        throw new Error(error?.message ?? 'Error while processing logout request')
      } finally {
        window.localStorage.removeItem('csoUserMobileNumber')
        window.localStorage.removeItem('csoSessData')
      }
    }),
  }))
  .views((self) => ({
    getQrList(searchValue: string) {
      if (searchValue.length === 0) {
        console.log('===> getQrList called')
        return self.midList.filter((item) => item.status === 'null')
      } else {
        return self.midList
          .filter((midItem) => midItem.status === 'null')
          .filter((item) =>
            isNaN(+searchValue)
              ? item.name.toLowerCase().includes(searchValue.toLowerCase())
              : item.id.startsWith(searchValue),
          )
      }
    },
  }))

const userInitialDataAgent = QrCodeUser.create({
  id: 0,
  mobile: '',
  jfsUserId: '',
  midList: [],
})

export type UserV2 = Instance<typeof QrCodeUser>
export { QrCodeUser, userInitialDataAgent }
